import { Router } from '@angular/router';
import { ElectionDto, ElectionType, ElectionsOverviewDto } from '@shared/clients/api.generated';
import { DateService } from '@shared/services/date-service.service';

export abstract class ElectionOverviewBaseComponent {
  protected electionsOverview: ElectionsOverviewDto | undefined
  protected electionTypes: ElectionType[] = [
    ElectionType.GeneralElection,
    ElectionType.MunicipalElection,
    ElectionType.RegionalElection,
    ElectionType.EuropeanParliamentElection,
    ElectionType.Referendum
  ];

  protected electionIdentifier = {
    [ElectionType.GeneralElection]: "fv",
    [ElectionType.MunicipalElection]: "kv",
    [ElectionType.RegionalElection]: "rv",
    [ElectionType.EuropeanParliamentElection]: "ev",
    [ElectionType.Referendum]: "fa"
  }

  constructor(
    protected readonly router: Router,
    protected readonly dateService: DateService,
    ) {}

  formatElectionDate(date: Date): string {
    return this.dateService.formatElectionDate(date);
  }

  protected getElections(electionType: ElectionType): ElectionDto[] | undefined {
    switch (electionType) {
      case ElectionType.GeneralElection:
        return this.electionsOverview?.generalElections;
      case ElectionType.MunicipalElection:
        return this.electionsOverview?.municipalElections;
      case ElectionType.RegionalElection:
        return this.electionsOverview?.regionalElections;
      case ElectionType.EuropeanParliamentElection:
        return this.electionsOverview?.europeanParliamentElections;
      case ElectionType.Referendum:
        return this.electionsOverview?.referendums;
    }
  }
}
